import { Component, HostListener, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { Store } from "@ngrx/store";
import { Table, TableLazyLoadEvent } from "primeng/table";
import { PaginationParams } from "src/app/model/api/pagination-params";
import { AppState } from "src/app/store/app.reducer";
import { ItemsPagination } from "src/app/model/api/data-rest";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ConfirmationService } from "primeng/api";
import { TranslateService } from "@ngx-translate/core";
import { selecMtmaModules, selectAccessLog, selectAccessLogExport, selectAccessLogPagination, selectCurrentDevice, selectCurrentDeviceCommands, selectCurrentDeviceModel, selectCurrentDeviceStatus, selectMtmaActions, } from "src/app/store/device/device.selector";
import { ACCESS_LOG_DEFAULT_SORT_COLUMN, ACCESS_LOG_DEFAULT_SORT_COLUMN_DIRECTION, ACCESS_LOG_PAGE_DEFAULT_SIZE, ACCESS_LOG_PAGE_SIZE_OPTIONS, ACCESS_LOG_TABLE_HEADER } from "src/app/conf/rbe-access-log";
import { DatePipe } from "@angular/common";
import { Device } from "src/app/model/device";
import * as DeviceActions from 'src/app/store/device/device.actions';
import { Observable, Subscription, debounceTime, filter } from "rxjs";
import { pageSortChange } from "src/app/services/table";
import { Command } from "src/app/model/command";
import { StandardDesignParameters, StandardDynamicComponent, StandardPageLayout } from "src/app/modules/shared/stdlayoutlib/classes.stdlayoutlib";
import { selectDeviceTabIndex } from "src/app/store/home/home.selector";
import { DeviceModel } from "src/app/model/device-model";
import { isMtmacModel } from "src/app/conf/device-models";
import { AccessEvent, AccessExportLog, ActionEvent } from "src/app/model/access-log";
import { exportToCsv } from "src/app/modules/shared/utils/exportData";
import moment from "moment";
import { MtmaAction } from "src/app/model/mtma-action";
import { MtmaModule, MtmaModuleConfig } from "src/app/model/mtma-module";
import { MtmaModuleType } from "src/app/conf/mtma-module";
import { ToggleButtonChangeEvent } from "primeng/togglebutton";
import { DeviceStatus } from "src/app/model/device-status";
import * as AnalyticsActions from 'src/app/store/analytics/analytics.actions';

@Component({
	selector: 'app-access-log',
	templateUrl: './access-log.component.html',
	providers: [ConfirmationService, DialogService]
})

export class AccessLogComponent implements OnInit, OnDestroy {
	@ViewChild(Table)
	table: Table;

	deviceModel$: Observable<DeviceModel | undefined>;
	deviceModelSub: Subscription | undefined;
	tabIndex: number;
	tabIndex$: Observable<number | undefined>;
	tabIndexSub: Subscription | undefined;
	mtmaActions$: Observable<MtmaAction[] | undefined>;
	mtmaActionsSub: Subscription | undefined;
	deviceStatus$: Observable<DeviceStatus | undefined>;
	deviceStatusSub: Subscription | undefined;

	commands$: Observable<Command[] | undefined>;
	commandsSub: Subscription | undefined;
	logs: AccessEvent[];
	logs$: Observable<AccessEvent[] | undefined>;
	logsSub: Subscription | undefined;
	logsExport$: Observable<AccessEvent[] | undefined>;
	logsExportSub: Subscription | undefined;
	mtmaModules$: Observable<MtmaModule[] | undefined>;
	mtmaModulesSub: Subscription | undefined;

	logsLoading: boolean;

	deviceModel: DeviceModel = new DeviceModel();
	currDevice: Device;
	currDevice$: Observable<Device | undefined>;
	currDeviceSub: Subscription | undefined;

	searchFilter: FormControl = new FormControl('');

	acceptButtonStyle: string;
	rejectButtonStyle: string;
	rejectButtonVisible: boolean;

	filter: '';
	// filterForm: FormGroup;
	accessFilterGroup: FormGroup;
	filterSub: Subscription;

	ref: DynamicDialogRef | undefined;

	MAX_EXPORT_LOG = 10000;

	columns = ACCESS_LOG_TABLE_HEADER;
	paging$: Observable<ItemsPagination | undefined>;
	pagingSub: Subscription;
	pageSortSub: Subscription;
	paging: PaginationParams = {
		size: ACCESS_LOG_PAGE_DEFAULT_SIZE,
		page: 1,
		sort: ACCESS_LOG_DEFAULT_SORT_COLUMN,
		order: ACCESS_LOG_DEFAULT_SORT_COLUMN_DIRECTION,
	};
	pageSize: number = ACCESS_LOG_PAGE_DEFAULT_SIZE;
	pageSizeOptions = ACCESS_LOG_PAGE_SIZE_OPTIONS;
	resultLength: number;

	dateTransform: DatePipe;

	minDate: Date = new Date("1900-01-01");
	today = new Date();
	maxDate = new Date();
	typeSub: Subscription;
	resultSub: Subscription;
	startDateSub: Subscription;
	endDateSub: Subscription;
	mtmaActions: MtmaAction[] = [];

	accessType: any[];
	accessResult: any[];
	commands: Command[];
	configured: boolean;
	online: boolean;

	saving = false;

	screenWidth: number;
	MIN_WIDTH_COL6 = StandardDesignParameters.MIN_WIDTH_COL6;
	COLUMN_TITLE_MIN_WD = 647;
	enabledLog: boolean = false;

	constructor(
		private store: Store<AppState>,
		public confirmationService: ConfirmationService,
		private translate: TranslateService,
		public dialogService: DialogService,
		private formBuilder: FormBuilder,
	) {
		this.initSelectors();
	}

	ngOnInit(): void {
		this.today = new Date();
		this.maxDate = new Date();
		this.maxDate.setHours(23);
		this.maxDate.setMinutes(59);
		this.store.dispatch(DeviceActions.getMtmaActions());
		/*--
		NONE: 0,
		BOARD_USER_UNDEFINED: 200,
		KEY: 201,
		TIMER_EVENT: 202,
		INPUT_ON: 203,
		INPUT_OFF: 204,*/
		this.accessType = [
			{ value: 0, label: 'ALL_ACCESS_TYPES' },
			{ value: 4, label: 'RADIOCOMANDO_KEYBOARD' },
			{ value: 5, label: 'RADIOCOMANDO_TRANSPONDER' },
			{ value: 202, label: 'TIMER_EVENT' },
			{ value: 206, label: 'LOG_WEB_COMMAND' },
			{ value: 207, label: 'LOG_Q&E_COMMAND' },
			{ value: 221, label: 'LOG_CALL_FROM' }
		];
		this.accessResult = [
			{ value: 0, label: 'ALL_EVENTS_RESULT' },
			{ value: 1, label: 'LOG_USER_SUCCESS' },
			{ value: 2, label: 'LOG_USER_NOT_PRESENT' },
			{ value: 3, label: 'LOG_USER_NOT_ENABLED_ON_THIS_GATE' },
			{ value: 4, label: 'LOG_USER_NOT_ENABLED_ON_THIS_TIME' },
			{ value: 20, label: 'LOG_AUTOMATION_OFFLINE' },
			{ value: 21, label: 'LOG_AUTOMATION_ERROR' },
			{ value: 40, label: 'LOG_CALL_REJECTED' },
			{ value: 41, label: 'LOG_CALL_USER_RESPONSE' },
			{ value: 42, label: 'LOG_CALL_USER_NOT_RESPONSE' },
		];

		const endDate = new Date(this.today.getTime());
		const startDate = new Date(this.today.getTime());
		startDate.setDate(startDate.getDate() - 7);
		const curreLang = this.translate.currentLang;
		this.dateTransform = new DatePipe(curreLang);

		this.accessFilterGroup = new FormGroup({
			'searchFilter': new FormControl(''),
			'type': new FormControl(this.accessType[0].value),
			'result': new FormControl(this.accessResult[0].value),
			'startDateTime': new FormControl(startDate, Validators.required),
			'endDateTime': new FormControl(endDate, Validators.required),
		});
		this.subscribeAll();
		this.onResize();

		this.filterSub = this.accessFilterGroup.valueChanges.pipe(
			debounceTime(500),
		).subscribe(() => {
			setTimeout(() => {
				this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'mtma_logaccess_change_filter', params: { page_title: 'MTMA | LogAccess' } }));
			}, 2000);
			this.table?.reset();
			this.dispatchGetLogs();
		});
	}

	ngOnDestroy(): void {
		this.logsSub?.unsubscribe();
		this.filterSub?.unsubscribe();
		this.pagingSub?.unsubscribe();
		this.currDeviceSub?.unsubscribe();
		this.typeSub?.unsubscribe();
		this.resultSub?.unsubscribe();
		this.startDateSub?.unsubscribe();
		this.endDateSub?.unsubscribe();
		this.commandsSub?.unsubscribe();
		this.tabIndexSub?.unsubscribe();
		this.deviceModelSub?.unsubscribe();
		this.mtmaActionsSub?.unsubscribe();
		this.mtmaModulesSub?.unsubscribe();
		this.deviceStatusSub?.unsubscribe();
	}

	initSelectors(): void {
		this.logs$ = this.store.select(selectAccessLog);
		this.currDevice$ = this.store.select(selectCurrentDevice);
		this.paging$ = this.store.select(selectAccessLogPagination);
		this.commands$ = this.store.select(selectCurrentDeviceCommands);
		this.tabIndex$ = this.store.select(selectDeviceTabIndex);
		this.deviceModel$ = this.store.select(selectCurrentDeviceModel);
		this.logsExport$ = this.store.select(selectAccessLogExport);
		this.mtmaActions$ = this.store.select(selectMtmaActions);
		this.mtmaModules$ = this.store.select(selecMtmaModules);
		this.deviceStatus$ = this.store.select(selectCurrentDeviceStatus);
	}

	subscribeAll(): void {
		this.deviceStatusSub = this.deviceStatus$.subscribe(deviceState => {
			if (deviceState) {
				this.configured = deviceState.Configured === 0;
				this.online = deviceState.Online;
			}
		});
		this.deviceModelSub = this.deviceModel$.pipe(filter(dm => !!dm))
			.subscribe(deviceModel => {
				this.deviceModel = deviceModel;
				this.dispatchGetLogs();
			});

		this.commandsSub = this.commands$.subscribe(
			commands => {
				this.commands = commands;
			}
		);

		this.logsSub = this.logs$.subscribe(
			(logs) => {
				this.logs = logs;
				this.logsLoading = false;
			}
		)

		this.currDeviceSub = this.currDevice$.subscribe(
			(device) => {
				this.currDevice = device
				this.dispatchGetLogs();
			}
		)

		this.pagingSub = this.paging$.subscribe((paging) => {
			if (paging !== undefined) {
				this.resultLength = paging.TotalCount;
				this.pageSize = paging.PageSize;
			}
		});

		this.tabIndexSub = this.tabIndex$?.subscribe(
			async (tabIndex: number) => {
				this.tabIndex = tabIndex;
				this.dispatchGetLogs();
			}
		);

		this.mtmaActionsSub = this.mtmaActions$.subscribe(mtmaActions => {
			this.mtmaActions = mtmaActions;
		});
		this.mtmaModulesSub = this.mtmaModules$.subscribe(mtmaModules => {
			const module = mtmaModules.filter(item => item.Type === MtmaModuleType.MTMAC)[0];
			if (module !== undefined && module.Config !== module.Config !== undefined && module.Config.EnableLogCall !== undefined) {
				this.enabledLog = module.Config.EnableLogAccess === 1;
			} else {
				this.enabledLog = false;
			}
		});
	}

	get f(): any {
		return this.accessFilterGroup.controls;
	}

	loadLogs(event: TableLazyLoadEvent) {
		this.paging = pageSortChange(this.paging, event);
		this.dispatchGetLogs();
	}

	translateData(str: string): string {
		let resStr = '';
		const fields = str.split('{{');
		for (const field of fields) {
			if (field.indexOf('}}') >= 0) {
				const toTranslate = field.split('}}');
				resStr = resStr + this.translate.instant('LOG_' + toTranslate[0]) + toTranslate[1];
			} else {
				resStr = resStr + field;
			}
		}
		return resStr;
	}

	userData(access: AccessEvent): string {
		if (access.Result === 2) {
			switch (access.Type) {
				case 4:
					return access.Code;
				case 5:
					return access.Code;
				default:
					return access.Code;
			}
		}
		switch (access.Type) {
			case 202:
				return '';
			// return this.translate.instant('TIMER_EVENT');
			case 205:
				return '';
			default:
				return this.translateData(access.Source);
		}
	}

	/*
	NONE: 0,
	RADIOSELECTOR: 17
	BOARD_USER_UNDEFINED: 200,
	KEY: 201,
	TIMER_EVENT: 202,
	INPUT_ON: 203,
	INPUT_OFF: 204,
	*/
	passageData(access: AccessEvent): string {
		if (access) {
			switch (access.Type) {
				case 4:
					return this.translate.instant('RADIOCOMANDO_KEYBOARD');
				case 5:
					return this.translate.instant('RADIOCOMANDO_TRANSPONDER');
				case 6:
					return this.translate.instant('LOG_KEYBOARD_Q&E_COMMAND');
				case 7:
					return this.translate.instant('LOG_RFID_TAG_Q&E_COMMAND');
				case 17:
					return this.translate.instant("BOARD_USER");
				case 200:
					return this.translate.instant('USER_UNKNOWN');
				case 202:
					return this.translate.instant('TIMER_EVENT');
				case 205:
					return this.translate.instant('LOG_WEB_COMMAND');
				case 206:
					return this.translate.instant('LOG_WEB_COMMAND');
				case 207:
					return this.translate.instant('LOG_Q&E_COMMAND');
				case 221:
					return this.translate.instant('LOG_CALL_FROM');
				default:
					return this.translateData(access.Passage);
			}
		} else {
			return "";
		}
	}

	/*
	NONE: 0,
	BOARD_USER_UNDEFINED: 200,
	KEY: 201,
	TIMER_EVENT: 202,
	INPUT_ON: 203,
	INPUT_OFF: 204,
	*/
	getType(access: AccessEvent): string {
		switch (access.Type) {
			case 0:
				return this.translate.instant('UNDEFINED');
			case 4:
				return this.translate.instant('RADIOCOMANDO_KEYBOARD');
			case 5:
				return this.translate.instant('RADIOCOMANDO_TRANSPONDER');
			case 200:
				return this.translate.instant('BOARD_USER_UNDEFINED');
			case 201:
				return this.translate.instant('KEY');
			case 202:
				return this.translate.instant('TIMER_EVENT');
			case 203:
				return this.translate.instant('INPUT_ON');
			case 204:
				return this.translate.instant('INPUT_OFF');
			case 205:
				return this.translate.instant('WEB_COMMAND');
			default:
				return this.translate.instant('BOARDUSER');
		}
	}

	/*
	 NONE: 0,
	 SUCCESS: 1,
	 NOT_PRESENT: 2,
	 NOT_ENABLED_ON_THIS_GATE: 3,
	 NOT_ENABLED_ON_THIS_TIME: 4,
	*/
	getResult(result: number): string {
		switch (result) {
			case 0:
				return this.translate.instant('UNDEFINED');
			case 1:
				return this.translate.instant('SUCCESS');
			case 2:
				return this.translate.instant('LOG_USER_NOT_PRESENT');
			case 3:
				return this.translate.instant('LOG_NOT_ENABLED_ON_THIS_GATE');
			case 4:
				return this.translate.instant('LOG_NOT_ENABLED_ON_THIS_TIME');
			default:
				return this.translate.instant('UNDEFINED');
		}
	}

	getAutomationActive(access: AccessEvent): string {
		let retString = '';
		const arrayString = [];
		if (access.ActionEvents !== null && access.ActionEvents.length > 0) {
			for (const event of access.ActionEvents) {
				if (event.DeviceName !== '') {
					if (event.Source != undefined && event.Source.indexOf('{{OUTPUT}}') >= 0) {
						arrayString.push(this.eventAccessOutput(event));
					} else if (event.Source != undefined && event.Source.indexOf('{{AUTOM1}}') >= 0) {
						arrayString.push(this.eventAccessAutomation(event, 2));
					} else if (event.Source != undefined && event.Source.indexOf('{{AUTOM2}}') >= 0) {
						arrayString.push(this.eventAccessAutomation(event, 3));
					}
				}
			}
		}
		if (arrayString.length === 0) {
			retString = '{{NOT_PASSAGE}}';
		} else {
			arrayString.sort((a, b) => {
				if (a.toLowerCase() < b.toLowerCase()) //sort string ascending
					return -1
				return 1
			});
			for (const str of arrayString) {
				if (retString === '') {
					retString = str;
				} else {
					retString = retString + ' | ' + str;
				}
			}
		}
		return this.translateData(retString);
	}

	eventAccessAutomation(event: ActionEvent, automationType: number): string {
		let action;
		if (event.Command === undefined) {
			return event.DeviceName;
		}
		if (event.Source.indexOf('{{TYPE_CMD_AUT}}') >= 0) {
			action = this.mtmaActions.find(ac => ac.Command === event.Command && ac.Type === automationType);
			if (action !== undefined) {
				return action.Traslation;
			} else {
				return event.DeviceName;
			}
		}
		if (event.Source.indexOf('{{TYPE_OUT}}') >= 0) {
			const outFind = '{out' + event.Command + '}';
			action = this.mtmaActions.find(ac => ac.Description.indexOf(outFind) > 0 && ac.Type === automationType);
			if (action !== undefined) {
				return action.Traslation;
			} else {
				return event.DeviceName;
			}
		}
		return '';
	}


	eventAccessOutput(event: ActionEvent): string {
		let action;
		if (event.Command === undefined) {
			return event.DeviceName;
		}
		switch (event.Command) {
			case 1000:
				action = this.mtmaActions.find(ac => ac.Command === 0 && ac.Type === 1);
				return action.Traslation;
			case 1001:
				action = this.mtmaActions.find(ac => ac.Command === 1 && ac.Type === 1);
				return action.Traslation;
			case 1002:
				action = this.mtmaActions.find(ac => ac.Command === 2 && ac.Type === 1);
				return action.Traslation;
			case 1003:
				action = this.mtmaActions.find(ac => ac.Command === 3 && ac.Type === 1);
				return action.Traslation;
			default:
				return event.DeviceName;
		}
	}


	translateOutputEvent(event: ActionEvent): string {
		let result;
		const str = event.DeviceName.split('{{OUTPUT}}');
		if (str !== undefined && str.length > 1) {
			result = str[1].trim();
		} else {
			return event.DeviceName;
		}
		if (this.commands != undefined && this.commands.length > 0) {
			if (result.indexOf('1') >= 0) {
				return this.convertStringOutput(event, 1);
			} else if (result.indexOf('2') >= 0) {
				return this.convertStringOutput(event, 2);
			} else if (result.indexOf('3') >= 0) {
				return this.convertStringOutput(event, 3);
			} else if (result.indexOf('4') >= 0) {
				return this.convertStringOutput(event, 4);
			}
		}
		return event.DeviceName;
	}

	convertStringOutput(event: ActionEvent, output: number) {
		const commIdOutput = 143 + output; //create id, output command
		const comm = this.commands.find(c => c.Id === commIdOutput);
		if (comm !== undefined) {
			return comm.Description;
		} else {
			return event.DeviceName;
		}
	}

	isMTMAConnect(): boolean {
		return this.deviceModel !== undefined && isMtmacModel(this.deviceModel.Id) && this.tabIndex >= 9; // TAB INDEX FOR MTMA LOG IS 8
	}

	isSelectLogTab(): boolean {
		return this.isMTMAConnect();
	}

	refresh(): void {
		this.today = new Date();
		this.maxDate = new Date();
		this.maxDate.setHours(23);
		this.maxDate.setMinutes(59);
		const endDate = new Date(this.today.getTime());
		this.f.endDateTime.setValue(endDate);
	}

	dispatchGetLogs(): void {
		if (this.isSelectLogTab()) {
			this.logsLoading = true;
			const startDateTime = this.f.startDateTime.value;
			const endDateTime = this.f.endDateTime.value;
			if (this.currDevice !== undefined && startDateTime !== undefined && endDateTime !== undefined) {
				this.store.dispatch(DeviceActions.getAccessLog({
					deviceId: this.currDevice.Id,
					startDate: startDateTime,
					endDate: endDateTime, filter: this.f.searchFilter.value, typeAction: this.f.type.value,
					result: this.f.result.value,
					sort: this.paging.sort.toLowerCase(), order: this.paging.order, size: this.paging.size, page: this.paging.page
				}));
			}
			// !! SI TRIGGERA SU PIU TAB (da AccessControl in poi) !!
			/* setTimeout(() => {
				this.store.dispatch(AnalyticsActions.eventDevice({ eventName: 'mtma_logaccess_dispatch', params: { page_title: 'MTMA | LogAccess' } }));
			}, 1000); */
		}
	}

	enableLog(event: ToggleButtonChangeEvent): void {
		const module = new MtmaModuleConfig();
		if (event.checked) {
			module.EnableLogAccess = 1;
		} else {
			module.EnableLogAccess = 0;
		}
		this.store.dispatch(DeviceActions.editParamMtmaModule({ module: module }));
	}

	//EXPORT
	exportLimitWarning(): void {
		this.acceptButtonStyle = "p-button-secondary";
		this.rejectButtonVisible = false;
		this.confirmationService.confirm({
			header: this.translate.instant('WARNING_EXPORT_LOG_TITLE'),
			message: this.translate.instant('WARNING_EXPORT_LOG_MESSAGE'),
			acceptLabel: this.translate.instant('CLOSE'),
			rejectLabel: this.translate.instant('CANCEL'),
			icon: 'pi cm-alert',
			accept: () => { },
			reject: () => { }
		});
	}

	exportToCsv() {
		if (this.resultLength > this.MAX_EXPORT_LOG) {
			this.exportLimitWarning();
		} else {
			this.saving = true;
			const startDateTime = this.f.startDateTime.value;
			const endDateTime = this.f.endDateTime.value;
			if (this.currDevice !== undefined && startDateTime !== undefined && endDateTime !== undefined) {
				this.logsLoading = true;
				this.store.dispatch(DeviceActions.getAccessLogExport({
					deviceId: this.currDevice.Id,
					startDate: startDateTime,
					endDate: endDateTime, filter: this.f.searchFilter.value, typeAction: this.f.type.value,
					result: this.f.result.value,
					sort: this.paging.sort.toLowerCase(), order: this.paging.order
				}));
			}
			this.logsExportSub = this.logsExport$.subscribe(
				(logs) => {
					if (logs !== undefined && logs.length > 0) {
						const data = this.prepareDataForLogs(logs);
						const map = new Map();
						map.set("EventDate", this.translate.instant('EVENT_DATE'));
						map.set("User", this.translate.instant('USER'));
						map.set("Passage", this.translate.instant('COMMAND_DEVICE'));
						map.set("Result", this.translate.instant('LOG_RESULT'));
						map.set("Automation", this.translate.instant('OUTPUT_AUTOMATIONS'));
						exportToCsv(data, 'exportData', map);
						this.logsExportSub?.unsubscribe();
						this.logsLoading = false;
						this.store.dispatch(DeviceActions.resetAccessLogExport());
						this.saving = false;
					}
				}
			)
		}
	}

	prepareDataForLogs(logs: AccessEvent[]): AccessExportLog[] {
		const list = [];
		for (const log of logs) {
			list.push(this.prepareDataForLog(log));
		}
		return list;
	}

	prepareDataForLog(log: AccessEvent): AccessExportLog {
		const logExport = new AccessExportLog();
		logExport.EventDate = moment.utc(log.EventDate).format('DD-MM-yyyy HH:mm:ss');
		logExport.User = this.userData(log);
		logExport.Passage = this.passageData(log);
		logExport.Result = this.getResult(log.Result);
		logExport.Automation = this.getAutomationActive(log);
		return logExport;
	}

	getActionEventLenght(actionEvent: ActionEvent[]): boolean {
		return actionEvent.length > 0;
	}

	getActionResultInfo(result: number): string {
		if (result) {
			switch (result) {
				case 0:
					return this.translate.instant("NOT_EXECUTE");
				case 1:
					return this.translate.instant("EXECUTED");
				case 20:
					return this.translate.instant("AUTOMATION_OFFLINE");
				case 21:
					return this.translate.instant("AUTOMATION_ERROR");
				default:
					return this.translate.instant("NOT_EXECUTE");
			}
		}
		return this.translate.instant("EXECUTED");
	}

	getActionResultColor(result: number): string {
		if (result) {
			switch (result) {
				case 0:
					return "danger";
				case 1:
					return "success";
				default:
					return "danger";
			}
		}
		return "success";
	}

	getDate(date: string): Date {
		const dateChange = moment.utc(date)
		return dateChange.toDate();
	}

	getAutomationName(action: ActionEvent): string {
		let retString = '';
		if (action.DeviceName !== '') {
			if (action.Source != undefined && action.Source.indexOf('{{OUTPUT}}') >= 0) {
				retString = this.eventAccessOutput(action);
			} else if (action.Source != undefined && action.Source.indexOf('{{AUTOM1}}') >= 0) {
				retString = this.eventAccessAutomation(action, 2);
			} else if (action.Source != undefined && action.Source.indexOf('{{AUTOM2}}') >= 0) {
				retString = this.eventAccessAutomation(action, 3);
			}
		}
		return this.translateData(retString);
	}

	// Design
	@HostListener('window:resize')
	onResize() {
		this.screenWidth = window.innerWidth;
	}

	onExtendedMobile(): boolean {
		return StandardPageLayout.onExtendedMobile(this.screenWidth);
	}

	underTablet(): boolean {
		return StandardPageLayout.underTablet(this.screenWidth);
	}

	dynamicInputTextWidth(): string {
		return StandardPageLayout.dynamicInputTextWidth(this.screenWidth, 'w-20rem');
	}

	col3ResponsiveStd(): string {
		return StandardPageLayout.col3ResponsiveStd(this.screenWidth);
	}

	col4Responsive(): string {
		return StandardPageLayout.col4ResponsiveStd(this.screenWidth);
	}

	col2Responsive(): string {
		return (this.screenWidth >= StandardDesignParameters.MIN_WIDTH_MX7_LATER) ? "col-2 px-4" : (this.screenWidth >= StandardDesignParameters.MIN_WIDTH_COL6) ? 'col-3' : 'col-6';
	}

	simpleInputTextLayout(classType: string): string {
		return StandardPageLayout.simpleInputTextLayout(classType, this.screenWidth);
	}

	dynamicAutocomplete(): string {
		return StandardDynamicComponent.dynamicAutocomplete(this.screenWidth);
	}
}